import { apiService } from '@/services/APIService';

export default {

  getPublicUserPlaces(id, params) {
    return apiService.get(`/public/places/event/${id}/users`, params);
  },

  getPublicTeamsPlaces(id, params) {
    return apiService.get(`/public/places/event/${id}/teams`, params);
  },
  // expand members!!!!
  getPublicTeams(id, params) {
    return apiService.get(`/public/events/${id}/teams`, params);
  },
  getPublicStageUserPlaces(id, params) {
    return apiService.get(`/public/places/event-stage/${id}/users`, params);
  },

  getPublicStageTeamsPlaces(id, params) {
    return apiService.get(`/public/places/event-stage/${id}/teams`, params);
  },

};
